import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

const formatDateForSql = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  return date.toISOString();
};

export const getSalaryAdvances = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/SalaryAdvance/get`, {
      Advance_Id: filter.Advance_Id || null,
      Employee_Id: filter.Employee_Id || null,
      Request_Date: filter.Request_Date ? formatDateForSql(filter.Request_Date) : null,
      Approved_Date: filter.Approved_Date ? formatDateForSql(filter.Approved_Date) : null
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("[SalaryAdvanceAPI] Failed to fetch advances:", error);
    throw error;
  }
};

export const saveSalaryAdvance = async (data) => {
  try {
    // Convert string amounts to numbers if they exist
    const requestAmount = typeof data.Request_Amount === 'string' ? parseFloat(data.Request_Amount) : data.Request_Amount;
    const approvedAmount = data.Approved_Amount ? (typeof data.Approved_Amount === 'string' ? parseFloat(data.Approved_Amount) : data.Approved_Amount) : null;
    const monthlyDeduction = data.Monthly_Deduction ? (typeof data.Monthly_Deduction === 'string' ? parseFloat(data.Monthly_Deduction) : data.Monthly_Deduction) : null;

    // Format dates for SQL Server
    const requestDate = formatDateForSql(data.Request_Date) || formatDateForSql(new Date());
    const approvedDate = data.isApproved ? formatDateForSql(data.Approved_Date) : null;

const payload = {
  Advance_Id: data.Advance_Id || 0,
  Employee_Id: data.Employee_Id,
  Request_Date: requestDate,
  Request_Amount: requestAmount,
  Approved_Date: approvedDate,
  Approved_Amount: approvedAmount,
  Monthly_Deduction: monthlyDeduction,
  Is_AutoDeduction: data.Is_AutoDeduction || null,
  CreatedDate: formatDateForSql(data.CreatedDate) || formatDateForSql(new Date()), // Ensure CreatedDate is passed
  ModifiedDate: formatDateForSql(data.ModifiedDate) || formatDateForSql(new Date()), // Ensure ModifiedDate is passed
  CreatedBy: data.CreatedBy,
  ModifiedBy: data.ModifiedBy,
  ApprovedBy: data.isApproved ? (data.ApprovedBy || null) : null,
};

    console.log("Sending payload to server:", payload);

    const response = await axios.post(`${BASE_URL}/api/SalaryAdvance/save`, payload, {
      headers: getAuthHeader(),
    });
    
    // If save is successful, refresh the page after a short delay
    if (response.data && response.data.success !== false) {
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
    
    return response.data;
  } catch (error) {
    console.error("[SalaryAdvanceAPI] Failed to save advance:", error);
    throw error;
  }
}; 